import { TypographyOptions } from '@mui/material/styles/createTypography'

export const typography: TypographyOptions = {
  body1: {
    fontSize: 14
  }
}

export default typography
